import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  Stack, TextField, Typography, Card, Grid } from '@mui/material';
import { openSnackbar } from '../../redux/slices/common';
import { addComplianceFeeData, fetchComplianceData } from '../../redux/slices/metrc';
import MDButton from 'components/MDButton';
import { isValidNumber } from 'utilities/common';

export default function ComplianceMetrc() {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        metrcComplianceFee: ""
    })
    const { loading: isBtnLoading = false } = useSelector(state => state?.metrc)

    const [errors, setErrors] = useState({})

    useEffect(() => {
        dispatch(fetchComplianceData())
            .unwrap()
            .then(res => {
                setFormData({ metrcComplianceFee: res?.metrcComplianceFee })
                // showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                // showResponseMessage(err?.message, 'error');
            });
    }, [])

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }

    const validateReasons = () => {
        let isError = false
        let errors = {}
        if (!formData?.metrcComplianceFee) {
            isError = true
            errors = { ...errors, metrcComplianceFee: 'Compliance Fee is required' }
        }

        return { errors, isError }
    }
    const submitHandler = () => {
        const { isError, errors } = validateReasons()
        setErrors(errors)
        if (isError) return;
        setErrors({})
        const payload = {
            metrcComplianceFee: Number(formData?.metrcComplianceFee)
        }
        dispatch(addComplianceFeeData({ data: payload }))
            .unwrap()
            .then(res => {
                showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                showResponseMessage(err?.message, 'error');
            });
    }

    return (
        <>
            <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2} mb={3}>
                    <Typography variant='h5'>Compliance Fee</Typography>
                </Stack>

                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12} md={12}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mb={2}>
                            <TextField
                                InputProps={{
                                    endAdornment: formData?.metrcComplianceFee ? '%' : "",
                                }}
                                className="form-input currency-field"
                                fullWidth
                                label={'Metrc Compliance Fee'}
                                name="metrcComplianceFee"
                                value={formData?.metrcComplianceFee || ''}
                                error={Boolean(errors?.metrcComplianceFee)}
                                onChange={(e) => {
                                    if (e.target.value && !isValidNumber(e.target.value)) return;
                                    setFormData({ ...formData, metrcComplianceFee: e.target.value });
                                }}
                                helperText={errors?.metrcComplianceFee}
                            />
                            <MDButton
                                sx={{ minWidth: '160px' }}
                                type='button'
                                variant='contained'
                                color='primary'
                                onClick={() => submitHandler()} disabled={isBtnLoading} loading={isBtnLoading}
                            >
                                Update
                            </MDButton>
                        </Stack>
                    </Grid>
                </Grid>
            </Card>
        </>
    );
}